import { useInView } from '@/lib/useInView'
import { useReducedMotion } from '@/lib/useReducedMotion'
import './SvgFrameSequence.css'

import zeroShotSvg from '@/assets/animations/zero-shot-agentic/zero-shot-agentic.svg?raw'
import '@/assets/animations/zero-shot-agentic/zero-shot-agentic.css'
import autoAssociateSvg from '@/assets/animations/auto-associate/auto-associate.svg?raw'
import '@/assets/animations/auto-associate/auto-associate.css'
import lineageByDefaultSvg from '@/assets/animations/lineage-by-default/lineage-by-default.svg?raw'
import '@/assets/animations/lineage-by-default/lineage-by-default.css'
import tokenAnonymizationSvg from '@/assets/animations/token-anonymization/token-anonymization.svg?raw'
import '@/assets/animations/token-anonymization/token-anonymization.css'

const SEQUENCES = {
  'zero-shot-agentic': zeroShotSvg,
  'auto-associate': autoAssociateSvg,
  'lineage-by-default': lineageByDefaultSvg,
  'token-anonymization': tokenAnonymizationSvg,
} as const

type SequenceName = keyof typeof SEQUENCES

type Props = {
  name: SequenceName
  ariaLabel: string
  className?: string
}

export function SvgFrameSequence({ name, ariaLabel, className }: Props) {
  const { ref, inView } = useInView<HTMLDivElement>({
    once: false,
    threshold: 0.1,
    rootMargin: '200px',
  })
  const reduced = useReducedMotion()
  const playing = inView && !reduced
  const svgMarkup = SEQUENCES[name]

  return (
    <div
      ref={ref}
      className={`svg-frame-seq${playing ? ' playing' : ''}${className ? ' ' + className : ''}`}
      data-sequence={name}
      role="img"
      aria-label={ariaLabel}
      dangerouslySetInnerHTML={{ __html: svgMarkup }}
    />
  )
}
